import React from "react";
import "./PrivacyPolicy.css";

function PrivacyPolicy() {
  return (
    <div className="legal-container">
      <h1>Privacy Policy</h1>
      <div className="legal-content">
        <h2>1. Introduction</h2>
        <p>
          At Pipelyze, your privacy is important to us. This policy explains how we collect, use, and protect your information when you use our services.
        </p>

        <h2>2. Information We Collect</h2>
        <ul>
          <li>Email address and account info you provide</li>
          <li>Usage data (such as repo URLs and activity)</li>
          <li>Payment info (handled securely via Stripe)</li>
        </ul>

        <h2>3. How We Use Information</h2>
        <ul>
          <li>To provide, operate, and improve our services</li>
          <li>To process transactions and communicate with you</li>
          <li>To enhance user experience and security</li>
        </ul>

        <h2>4. Data Sharing</h2>
        <p>
          We do not sell or rent your data. We only share with trusted partners (like payment processors) as needed to deliver our services.
        </p>

        <h2>5. Your Rights</h2>
        <p>
          You may request, update, or delete your personal information at any time. Contact us at{" "}
          <a href="mailto:support@pipelyze.com">support@pipelyze.com</a>.
        </p>

        <h2>6. Changes</h2>
        <p>
          We may update this policy. We’ll notify users of significant changes.
        </p>

        <div className="legal-footer">Last updated: July 20, 2025</div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
